import * as React from 'react';
import { Row, Form, InputGroup, FormControl, Button, Spinner } from 'react-bootstrap';

import { ICovid19DeclarationState } from './interfaces/ICovid19DeclarationState';
import Covid19Service from './Covid19Service';
import { ICovid19Payload } from './interfaces/ICovid19Payload';

import './Covid19DeclarationStyle.scss';

let timeout: number;

class Covid19Declaration extends React.Component<{}, ICovid19DeclarationState> {

    constructor(props: any) {
        super(props);

        this.state = {
            validated: false,
            disableForm: true,
            processingForm: false,
            formId: '',
            showCloseWindow: false,
            validateFullname: false,
            validateEmail: false,
            validateConfirm: false
        }
    }

    public async componentDidMount() {
        document.title = "CFC | Covid-19 Declaration Form";
        const urlParams = new URLSearchParams(window.location.search);
        const myParam = urlParams.get('code');

        const pFormStatus = document.getElementById('pFormStatus') as HTMLLabelElement;

        if (myParam !== undefined && myParam !== null) {
            const divSpinner = document.getElementById('divSpinner') as HTMLDivElement;
            divSpinner.className = "showLbl";

            await Covid19Service.fillCovid19FormWithId(myParam, (result: ICovid19Payload | string, isSuccess: boolean) => {
                divSpinner.className = "hideLbl";

                if (isSuccess) {
                    const takePayload = result as ICovid19Payload;
                    const tbFullName = document.getElementById('tbFullName') as HTMLInputElement;
                    tbFullName.value = takePayload.fullName;
                    const tbEmailAddress = document.getElementById('tbEmailAddress') as HTMLInputElement;
                    tbEmailAddress.value = takePayload.email;

                    this.setState({ disableForm: false, formId: myParam });

                } else {
                    pFormStatus.className = "showLbl";
                    pFormStatus.innerText = result as string;
                    pFormStatus.style.color = "red";
                }
            });

        } else {
            pFormStatus.className = "showLbl";
            pFormStatus.innerText = "Failed validation required to load form";
            pFormStatus.style.color = "red";
        }
        console.log(myParam);
    }

    public componentWillUnmount() {
        window.clearTimeout(timeout);
    }

    public render() {
        const { validated, disableForm, processingForm, validateFullname, validateEmail, validateConfirm, formId, showCloseWindow } = this.state;
        return (
            <Row>
                {
                    (disableForm && formId.length === 0) &&
                    <div className="spinnerWrapper">
                        <div id="divSpinner" className="hideLbl">
                            <Spinner animation="border" role="status" variant="secondary" />
                            <span className="spinnerInfo">Loading your information...</span>
                        </div>
                        <label id="pFormStatus" className="hideLbl" />
                    </div>
                }

                {
                    !showCloseWindow &&
                    <div className="divContentWrapper">
                        <p className="divSubheading">Peronal Information</p>
                        <div>
                            Your admission to Stamford Bridge Stadium or Kingsmeadow Stadium (the “Stadium”) is conditional
                            on you completing this questionnaire and complying with the Chelsea FC (the “Club”) COVID-19 Code
                            of Conduct.  Prior to entering the Stadium site, you will be required to provide the information
                            and confirmations below.
                    </div>
                    </div>
                }

                {
                    !showCloseWindow &&
                    <Form noValidate validated={validated} onSubmit={this.onSubmit} className={(disableForm && formId.length === 0) ? 'disableForm' : 'enableForm'}>
                        <div className="divContentWrapper marginTop20">
                            <p className="divSubheading">Full Name (AS PRINTED ON YOUR TICKET)</p>
                            <div>
                                <Form.Control id="tbFullName" type="text" placeholder="Your full name" required isInvalid={validateFullname} disabled={true} />
                                <Form.Control.Feedback type="invalid">Full name required</Form.Control.Feedback>
                            </div>
                        </div>

                        <div className="divContentWrapper marginTop20">
                            <p className="divSubheading">Email Address</p>
                            <div>
                                <InputGroup>
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>@</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <FormControl id="tbEmailAddress" type="email" placeholder="Your email" required isInvalid={validateEmail} disabled={true} />
                                    <Form.Control.Feedback type="invalid">Valid email required</Form.Control.Feedback>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="divContentWrapper marginTop20">
                            <p className="divSubheading">I CONFIRM THAT I:</p>
                            <div>
                                <p>1. have not tested positive for COVID-19 in the last 10 days; </p>
                                <p>
                                    2. do not have any recognised COVID-19 symptoms (including but not limited to a temperature
                                    of 37.8 degrees or above, a new continuous cough, and/or a loss or change in sense of taste/smell);
                        </p>
                                <p>
                                    3. have not been in close contact with a confirmed case of COVID-19 at any time during the past 14 days,
                                    the result of which would require me to self-isolate under the current Government, NHS and Public Health
                                    England guidelines;
                        </p>
                                <p>
                                    4. have not been told that I have been in close contact with a confirmed case of COVID-19 by the NHS Test
                                    and Trace system and told to self-isolate;
                        </p>
                                <p>
                                    5. do not live in, nor have I travelled from, a COVID Local Area Tier 3 location; and
                        </p>
                                <p>
                                    6. have not travelled outside of the UK within the last 14 days to a country that the Government requires me
                                    to self-isolate for 14 days upon returning to the UK (a country that is not exempt from the quarantine rules).
                        </p>
                                <br />
                                <p>
                                    If any of the statements above are not true and accurate now or prior to the playing of the Match, I understand
                                    that I must not attend the Stadium.
                        </p>
                                <p>
                                    All match tickets are sold subject to the Chelsea Football Club Limited Covid-19 – Return of Spectators - Match
                            Ticket Conditions of Issue, a copy of which can be found at <a href="https://bit.ly/2JJcj4z" target="_blank" rel="noreferrer">https://bit.ly/2JJcj4z</a>
                                </p>
                                <p>
                                    All supporters must comply with our COVID-19 Code of Conduct, which forms part of our Conditions of Issue. You can
                            read the Code of Conduct here: <a href="https://bit.ly/3lSlxZe" target="_blank" rel="noreferrer">https://bit.ly/3lSlxZe</a>
                                </p>
                                <br />
                                <p>By submitting this Declaration you are agreeing to the Conditions of Issue and the Code of Conduct.</p>
                            </div>
                        </div>

                        <div className="marginTop20 divContentWrapper2">
                            <Form.Check id="radioConfirm" type="radio" name="radioConfirm" label="I understand and agree" required isInvalid={validateConfirm} disabled={disableForm} />
                            <Form.Control.Feedback type="invalid">Confirmation required</Form.Control.Feedback>
                        </div>

                        <div className="divSubmit">
                            <Button type="submit" className="btnCFCBrand" block disabled={disableForm}>Submit</Button>
                            {
                                processingForm &&
                                <Spinner animation="border" variant="primary" className="marginLeft5 verticalAlignMiddle" />
                            }
                            <div id="divSubmitStatus" className="hideLbl"></div>
                        </div>
                    </Form>
                }

                {
                    showCloseWindow &&
                    <div className="divContentWrapper closeWindow">
                        <p className="divSubheading">All done!</p>
                        <div>Close the page to exit</div>
                    </div>
                }
            </Row>
        );
    }

    private onSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            //Form failed...
            //out of the box validaion feedback doesn't work, so a custom method is used for displaying validation feedback
            this.ValidationFeedbacks();
        } else {
            //Form passed...
            this.setState({ validateFullname: false, validateEmail: false, validateConfirm: false, disableForm: true, processingForm: true }, async () => {
                //Send form to backend - I think only the guid param is required
                await Covid19Service.submitCovid19FormWithId(this.state.formId, (result: string, isSuccess: boolean) => {
                    const divSubmitStatus = document.getElementById('divSubmitStatus') as HTMLDivElement;
                    if (isSuccess) {
                        this.setState({ processingForm: false }, () => {
                            divSubmitStatus.className = "marginTop10 showLbl success";
                            divSubmitStatus.innerText = result;

                            timeout = window.setTimeout(() => {
                                this.setState({ showCloseWindow: true });
                            }, 4000);
                        });
                    } else {
                        //Some error occurred
                        this.setState({ disableForm: false, processingForm: false }, () => {
                            divSubmitStatus.className = "marginTop10 showLbl";
                            divSubmitStatus.innerText = result;
                        });
                    }
                });
            });
        }

        event.preventDefault();
        event.stopPropagation();
    }

    private ValidationFeedbacks = () => {
        let stateValidateFullname = false;
        let stateValidateEmail = false;
        let stateValidateConfirm = false;

        let focusSetAlready = false;

        const tbFullName = document.getElementById('tbFullName') as HTMLInputElement;
        const fullName = tbFullName.value === undefined ? '' : tbFullName.value.trim();
        if (fullName.length === 0) {
            stateValidateFullname = true;
            focusSetAlready = true;
            tbFullName.focus();
        }

        const tbEmail = document.getElementById('tbEmailAddress') as HTMLInputElement;
        const email = tbEmail.value === undefined ? '' : tbEmail.value.trim();
        const regEx = new RegExp(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);
        if (email.length === 0 || !regEx.test(email)) {
            stateValidateEmail = true;
            if (!focusSetAlready) {
                focusSetAlready = true;
                tbEmail.focus();
            }
        }

        const radioConfirm = document.getElementById('radioConfirm') as HTMLInputElement;
        if (!radioConfirm.checked) {
            stateValidateConfirm = true;
            if (!focusSetAlready) {
                focusSetAlready = true;
                radioConfirm.focus();
            }
        }

        this.setState({
            validateFullname: stateValidateFullname,
            validateEmail: stateValidateEmail,
            validateConfirm: stateValidateConfirm
        });
    }
}

export default Covid19Declaration;